var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ProOnlyAlertBox',{attrs:{"options":{
    feature: 'presets',
    content: `Design Presets are only available in Breakdance Pro. They won\'t work on the frontend.`
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }